import React from 'react'
import cx from 'classnames'
import { DonationCampaign } from '../../types'
import style from './CampaignSelector.module.scss'

interface CampaignSelectorProps {
    campaigns: DonationCampaign[]
    selectedCampaign: DonationCampaign
    setSelectedCampaign: (campaign: DonationCampaign) => void
}

const CampaignSelector: React.FC<CampaignSelectorProps> = ({
    campaigns,
    selectedCampaign,
    setSelectedCampaign,
}) => {
    // If only one campaign, no need to show selector
    if (campaigns.length <= 1) {
        return null
    }

    return (
        <div className={style.campaignSelectorContainer}>
            <div className={style.campaignSelector}>
                {campaigns.map((campaign) => (
                    <button
                        key={campaign.id}
                        type="button"
                        className={cx({
                            [style.selected]:
                                selectedCampaign?.id === campaign.id,
                        })}
                        onClick={() => setSelectedCampaign(campaign)}
                    >
                        {campaign.icon && (
                            <div className={style.campaignIcon}>
                                <img alt={campaign.name} src={campaign.icon} />
                            </div>
                        )}
                        {campaign.name}
                    </button>
                ))}
            </div>
        </div>
    )
}

export default CampaignSelector
